export const ShipmentItemStatus = Object.freeze({
  AGUARDANDO_CONFIRMACAO: 1,
  ENTREGUE: 2,
  CANCELADO: 3,
  PARCIALMENTE_ATENDIDO: 4,
});

export const ShipmentItemStatusEnumById = {
  [ShipmentItemStatus.AGUARDANDO_CONFIRMACAO]: "Aguardando Confirmação",
  [ShipmentItemStatus.ENTREGUE]: "Entregue",
  [ShipmentItemStatus.CANCELADO]: "Retornou",
  [ShipmentItemStatus.PARCIALMENTE_ATENDIDO]: "Parcialmente Atendido",
};
